import React from "react";
import { Background } from "../../../BuildingBlocks/Background";
import { FrontColors } from "../../../../models/FrontColors";
import { Padding } from "../../../BuildingBlocks/Padding";
import { Flex } from "../../../BuildingBlocks/Flex";
import { Width } from "../../../BuildingBlocks/Width";
import { FPMarketingSectionTitle } from "../../Simple/FPMarketingSectionTitle/FPMarketingSectionTitle";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FPFooter } from "../../Simple/FPFooter/FPFooter";
import { pipe } from "fp-ts/lib/function";
import { array } from "fp-ts";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { FPGuideDesktop } from "../../Simple/FPGuide/FPGuideDesktop";

export const fpLandingPageGuidesViewGuides = [
    {
        imageUrl: "/static/img/probate-guide-1.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-to-find-a-will/",
        blurb: "How to find a will.",
    },
    {
        imageUrl: "/static/img/probate-guide-2.jpg",
        href: "https://blog.sailprobate.co.uk/posts/finding-the-deceased-assets/",
        blurb: "Finding and valuing a deceased person's assets.",
    },
    {
        imageUrl: "/static/img/probate-guide-3.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-do-i-obtain-a-copy-of-a-grant-of-probate/",
        blurb: "How do I obtain a copy of a Grant of Probate?",
    },
    {
        imageUrl: "/static/img/probate-guide-4.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-does-probate-work-if-there-is-no-will/",
        blurb: "How does probate work if there is no will?",
    },
    {
        imageUrl: "/static/img/probate-guide-5.jpg",
        href: "https://blog.sailprobate.co.uk/posts/can-you-apply-for-probate-online/",
        blurb: "Can you apply for probate online?",
    },
    {
        imageUrl: "/static/img/probate-guide-6.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-long-does-a-probate-property-sale-take/",
        blurb: "How long does a probate property sale take?",
    },
    {
        imageUrl: "/static/img/probate-guide-7.jpg",
        href: "https://blog.sailprobate.co.uk/posts/how-do-i-know-if-need-to-apply-for-probate/",
        blurb: "How do I know if I need to apply for probate?",
    },
    {
        imageUrl: "/static/img/probate-guide-8.jpg",
        href: "https://blog.sailprobate.co.uk/posts/do-you-have-to-have-a-solicitor-for-probate/",
        blurb: "Do you have to have a solicitor for probate?",
    },
];

export const FPLandingPageGuidesViewDesktop = (): JSX.Element => {
    const guides =
        pipe(
            fpLandingPageGuidesViewGuides,
            array.chunksOf(4),
        );

    return <Background
        color={FrontColors.PROBATE_0}
        minHeight="100vh"
    >
        <Flex
            direction="column"
            justifyContent="space-between"
            minHeight="100vh"
            gap="90px"
        >
            <Flex justifyContent="center">
                <Width width="1200px">
                    <Padding spacing="90px 40px 0px 40px">
                        <SpacingColumn spacing="25px">
                            {/* TITLE */}
                            <FPMarketingSectionTitle color={FrontColors.NEUTRAL_18}>
                                Read our probate guides
                            </FPMarketingSectionTitle>

                            {/* GUIDES */}
                            <SpacingColumn spacing={FrontSpacing.LARGE_2}>
                                {pipe(
                                    guides,
                                    array.mapWithIndex((chunkI, chunk) =>
                                        <SpacingRow
                                            key={chunkI}
                                            alignItems="flex-start"
                                        >
                                            {pipe(
                                                chunk,
                                                array.mapWithIndex((guideI, guide) =>
                                                    <FPGuideDesktop
                                                        key={guideI}
                                                        href={guide.href}
                                                        imageUrl={guide.imageUrl}
                                                        blurb={guide.blurb}
                                                    />
                                                )
                                            )}
                                        </SpacingRow>
                                    )
                                )}
                            </SpacingColumn>
                        </SpacingColumn>
                    </Padding>
                </Width>
            </Flex>

            {/* FOOTER */}
            <Padding spacing="0px 0px 50px 0px">
                <FPFooter />
            </Padding>
        </Flex>
    </Background>;
};
